import React from "react"
import { initiateCheckoutAnalytics } from './../../helpers/analytics'

export default function MiniCart({ appProps }) {
  return (
    <div className="pointer reservation_icon" onClick={(e) => { location.href = appProps.currentReservationPath }} />
  )
}
